import React from "react";

export default function Impressum() {
  return (
    <div>
      <section className="py-24 md:py-32 bg-[#F8FAFC]" data-testid="impressum-header">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <span className="text-sm font-semibold tracking-wide uppercase text-[#FF3B30]" style={{ fontFamily: 'Plus Jakarta Sans' }}>
            Rechtliches
          </span>
          <h1
            className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#0F172A] mt-3"
            style={{ fontFamily: 'Plus Jakarta Sans' }}
            data-testid="impressum-page-title"
          >
            Impressum
          </h1>
        </div>
      </section>

      <section className="py-24 md:py-32" data-testid="impressum-content">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <div className="space-y-10">
            <div>
              <h2 className="text-sm font-semibold tracking-wide uppercase text-slate-500 mb-3" style={{ fontFamily: 'Plus Jakarta Sans' }}>
                Firmenname
              </h2>
              <p className="text-[#0F172A] text-lg font-medium" style={{ fontFamily: 'Plus Jakarta Sans' }}>
                ServicePoint Huwiler
              </p>
            </div>

            <div className="border-t border-slate-100 pt-10">
              <h2 className="text-sm font-semibold tracking-wide uppercase text-slate-500 mb-3" style={{ fontFamily: 'Plus Jakarta Sans' }}>
                Inhaberin
              </h2>
              <p className="text-[#0F172A] text-base">Sarah Huwiler</p>
            </div>

            <div className="border-t border-slate-100 pt-10">
              <h2 className="text-sm font-semibold tracking-wide uppercase text-slate-500 mb-3" style={{ fontFamily: 'Plus Jakarta Sans' }}>
                Adresse
              </h2>
              <div className="text-[#0F172A] text-base space-y-1">
                <p>Sellackerstrasse 3</p>
                <p>6033 Buchrain</p>
                <p>Schweiz</p>
              </div>
            </div>

            <div className="border-t border-slate-100 pt-10">
              <h2 className="text-sm font-semibold tracking-wide uppercase text-slate-500 mb-3" style={{ fontFamily: 'Plus Jakarta Sans' }}>
                Kontakt E-Mail
              </h2>
              <a
                href="mailto:servicepoint.huwiler89@gmail.com"
                className="text-[#FF3B30] hover:underline text-base"
                data-testid="impressum-email-link"
              >
                servicepoint.huwiler89@gmail.com
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
